<div>
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center" animationDuration="0ms">
    <mat-tab label="Download">
      <dx-scroll-view>
        <div class="inputFields">
          <div fxLayout="row wrap" fxLayoutGap="20px grid">
            <div class="alignCenter label" fxFlex="100">{{ res.get('CacheConfig-Status') }}</div>

            <div fxFlex="40" class="dxfieldLabel">{{ res.get('CacheConfig-OnlineStatus') }}</div>
            <div fxFlex="60">
              <mat-icon
                class="onlineStateIcon"
                svgIcon="{{
                  this.cacheService.isOnline
                    ? !this.cacheService.useOfflineMode
                      ? res.svgName('OnlineStates-DotGreen-Image')
                      : res.svgName('OnlineStates-DotOrange-Image')
                    : res.svgName('OnlineStates-DotRed-Image')
                }}"
              ></mat-icon>
              <div class="onlineStateIconText">
                {{ this.getOnlineStateText() }}
              </div>
            </div>

            <div fxFlex="40" fxFlex.xs="100" class="alignCenter">Schwellenwert Offline (ms)</div>
            <div fxFlex="60" fxFlex.xs="100">
              <abcSelectBox
                [style]="4"
                [valueExpr]="'valueOfflineTimeout'"
                [displayExpr]="'designation'"
                [dataSource]="offlineTimeoutSource"
                [(value)]="valueOfflineTimeout"
                (onValueChanged)="changeOfflineTimeout($event.value)"
                [stylingMode]="'underlined'"
                [disabled]="!offlineTimeoutSource?.length || inputFieldsDisabled"
              ></abcSelectBox>
            </div>

            <div fxFlex="40" fxFlex.xs="100" class="dxfieldLabel">{{ res.get('CacheConfig-CacheUsage') }}</div>
            <div fxFlex="50" fxFlex.xs="90">
              {{
              this.cacheService.isStorageAvailable
              ? this.cacheService.cacheInfoText
              : res.get('CacheConfig-StorageUnvailable')
              }}
            </div>
            <div fxFlex="10" fxFlex.xs="10" style="text-align: end">
              <abcButton
                [id]="'clearCache'"
                [style]="4"
                [icon]="'trash'"
                [width]="'24px'"
                [height]="'24px'"
                [disabled]="!this.cacheService.isStorageAvailable || inputFieldsDisabled"
                (click)="this.clearCache()"
                >
              </abcButton>
            </div>
          </div>

          <div fxLayout="row wrap" fxLayoutGap="20px grid">
            <div class="label" fxFlex="100" style="margin-top: 20px">{{ res.get('CacheConfig-MapSettings') }}</div>

            <div fxFlex="40" fxFlex.xs="100" class="alignCenter">{{ res.get('CacheConfig-MaxZoomLevel') }}</div>
            <div fxFlex="60" fxFlex.xs="100">
              <abcSelectBox
                [style]="4"
                [valueExpr]="'tileLevel'"
                [displayExpr]="'designation'"
                [dataSource]="tileLevelSource"
                [(value)]="tileLevel"
                (onValueChanged)="changeTileLevel($event.value)"
                [stylingMode]="'underlined'"
                [disabled]="
                  !tileLevelSource?.length ||
                  (tileLevelSource.length === 1 && tileLevelSource[0].tileLevel < 0) ||
                  inputFieldsDisabled
                "
              ></abcSelectBox>
            </div>

            <div fxFlex="40" fxFlex.xs="100" class="alignCenter">{{ res.get('CacheConfig-Detail') }}</div>
            <div fxFlex="60" fxFlex.xs="100">
              <abcSelectBox
                valueExpr="id"
                displayExpr="designation"
                [dataSource]="extentSource"
                [(value)]="extent"
                (onValueChanged)="changeExtentMode($event.value)"
                [stylingMode]="'underlined'"
                [disabled]="inputFieldsDisabled"
              ></abcSelectBox>
            </div>
          </div>
        </div>
        <div class="inputFields">
          <div fxLayout="row wrap" fxLayoutGap="0px grid">
            <div class="label" fxFlex="100">{{ res.get('CacheConfig-DownloadData') }}</div>
            <div fxFlex="100">
              <div fxFlex="70">
                <dx-progress-bar
                  class="dx-field-label"
                  [width]="'100%'"
                  [min]="0"
                  [max]="1"
                  [value]="this.progressPercentage"
                  [statusFormat]="this.statusFormat"
                ></dx-progress-bar>
              </div>
              <div fxFlex="30">
                <abcButton
                  [id]="'btnDownload'"
                  [style]="4"
                  [width]="'100%'"
                  [value]="
                    this.cacheService.progressState === ProgressState.Idle
                      ? res.get('CacheConfig-Download')
                      : res.get('CacheConfig-Cancel')
                  "
                  (onClick)="handleCaching()"
                  [disabled]="
                    this.cacheService.forceOfflineMode ||
                    !this.cacheService.isOnline ||
                    !this.cacheService.isServerAvailable ||
                    !this.cacheService.isStorageAvailable ||
                    !this.cacheService.storage.getCacheableItems().length ||
                    this.cacheService.progressState === ProgressState.Cancelling
                  "
                  >
                </abcButton>
              </div>
            </div>
          </div>
        </div>
        <div class="error-message">
          {{
          this.cacheService.errorRatio
          ? res.get('CacheConfig-ErrorMessage', this.cacheService.lastErrorMessage)
          : null
          }}
        </div>
      </dx-scroll-view>
    </mat-tab>
    @if (this.frame.frameConfig.showImageSettingsTab) {
      <mat-tab label="Fotos">
        <div class="inputFields" fxLayout="column">
          <div class="alignLeft label" fxFlex="100">Bildformat</div>
          <div
            class="dx-field custom-height-slider"
            style="display: flex; flex-direction: row; align-items: center; padding-bottom: 10px"
            >
            <div class="dx-field-label" style="width: 120px">
              Vertikale <br />
              Auflösung
            </div>
            <div class="dx-field-value" style="flex: 2">
              <dx-slider
                [min]="720"
                [max]="2560"
                [step]="10"
                [value]="pictureResolution"
                [rtlEnabled]="false"
                (onValueChanged)="pictureResolutionChanged($event)"
                >
                <dxo-slider-label [visible]="true" position="top"></dxo-slider-label>
              </dx-slider>
            </div>
            <div style="flex: 1; display: flex; justify-content: center; align-items: center">
              <mat-label>{{ pictureResolution + ' px' }}</mat-label>
            </div>
          </div>
          <div class="dx-field custom-height-slider" style="display: flex; flex-direction: row; align-items: center">
            <div class="dx-field-label" style="width: 120px">Qualität</div>
            <div class="dx-field-value" style="flex: 2">
              <dx-slider
                [min]="10"
                [max]="100"
                [value]="pictureQuality"
                [rtlEnabled]="false"
                (onValueChanged)="pictureQualityChanged($event)"
                >
                <dxo-slider-label [visible]="true" position="top"></dxo-slider-label>
              </dx-slider>
            </div>
            <div style="flex: 1; display: flex; justify-content: center; align-items: center">
              <mat-label>{{ pictureQuality + ' %' }}</mat-label>
            </div>
          </div>
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</div>
